/**
 * Green Bubble - sierpot-kiezer: model- en kleurlaag
 * ---------------------------------------------------------------------------
 * Groepeert de potkaarten in de "Kies je sierpot"-strook per POTMODEL, zodat er
 * nog maar een kaart per model in de rij staat. Onder de strook verschijnt een
 * KLEUR-rij met de beschikbare kleuren van het gekozen model.
 *
 * Deze laag staat bewust LOS van assets/app.js (dat is een webpack-build uit de
 * src-repo van het bureau en wordt bij elke nieuwe build overschreven). Dit
 * bestand raakt die bundel niet aan: het wacht tot initOppotConfigurator klaar
 * is en herschikt daarna alleen de bestaande DOM-knopen. Omdat de kaarten
 * worden VERPLAATST en niet gekopieerd, blijven alle jQuery-handlers die
 * PotFinder er bij init op heeft gezet gewoon werken.
 *
 * Model + kleur komen uit de metafields custom.pot_model / custom.pot_kleur.
 * Zolang die nog niet gevuld zijn, worden ze afgeleid uit de producttitel.
 */
(function () {
  'use strict';

  // Het thema bundelt jQuery via webpack en zet alleen `window.$`, niet `window.jQuery`.
  var $ = window.jQuery || window.$;
  if (!$ || !$.fn) return;

  // ---------------------------------------------------------------------------
  // Titel-fallback: "Pot Elho Greenville golden sand" -> model "Elho Greenville",
  // kleur "golden sand". Werkt door vanaf het EIND kleurwoorden af te pellen en
  // te stoppen bij het eerste woord dat geen kleur is.
  // ---------------------------------------------------------------------------
  // Het producttype hoort BIJ de groepering: een vaas en een sierpot met dezelfde
  // modelnaam (Elisa) zijn twee verschillende producten en krijgen dus elk een
  // eigen tegel met een eigen kleurenrij. Titels zonder typewoord
  // ("Fabien mystic green") vallen terug op 'pot' — dat is het standaardgeval.
  var TYPE_WORDS = {
    pot: 'pot', potten: 'pot', sierpot: 'pot', sierpotten: 'pot',
    vaas: 'vaas', vazen: 'vaas',
    mand: 'mand', manden: 'mand',
    schaal: 'schaal', schalen: 'schaal',
    plantenbak: 'plantenbak', plantenbakken: 'plantenbak'
  };
  // Woorden die vóór de modelnaam staan maar niets over het model zeggen.
  // "Pot Jumbo Patt Ivory Washed" is gewoon Patt in een groter formaat - de maat
  // zit al in de varianten en in het filter op potopening, dus hier is Jumbo
  // ruis die het model onnodig zou opsplitsen.
  var IGNORE_LEAD = { set: true, jumbo: true };
  var DEFAULT_TYPE = 'pot';

  var COLOR_WORDS = [
    // NL
    'antraciet', 'beige', 'zwart', 'wit', 'zijdewit', 'groen', 'grijs', 'geel',
    'goud', 'gouden', 'roze', 'blauw', 'bruin', 'naturel', 'cement', 'mokka',
    'zilver', 'rood', 'oranje', 'paars', 'lila', 'creme', 'crème', 'okergeel',
    'oker', 'taupe', 'terracotta', 'terra', 'roest', 'zand', 'linnen', 'parel',
    'donkergroen', 'lichtgroen', 'donkergrijs', 'lichtgrijs', 'donkerblauw',
    'lichtblauw', 'gebroken', 'steen', 'olijf', 'olijfgroen', 'mint', 'zalm',
    // EN / merkbenamingen
    'anthracite', 'charcoal', 'black', 'white', 'ivory', 'cream', 'green',
    'grey', 'gray', 'yellow', 'gold', 'golden', 'pink', 'blue', 'brown',
    'natural', 'mocha', 'silver', 'red', 'orange', 'purple', 'lavender',
    'amber', 'olive', 'rust', 'sand', 'stone', 'clay', 'coral', 'denim',
    'khaki', 'sage', 'ocean', 'forest', 'ruby', 'pearl', 'camel', 'latte',
    'rose', 'blush', 'nude', 'sahara', 'jade', 'petrol', 'aqua', 'turquoise',
    'bordeaux', 'plum', 'peach', 'apricot', 'chocolate', 'coffee', 'espresso',
    'graphite', 'grafiet', 'platinum', 'nickel', 'nikkel', 'titanium', 'chrome',
    'chroom', 'ivoor', 'cognac', 'cotta', 'shell', 'linen', 'ash', 'smoke',
    'earth', 'copper', 'bronze', 'brass', 'moss', 'sky',
    // steen- en metaalnamen die hier als kleur gebruikt worden
    'concrete', 'laterite', 'lead', 'dioriet', 'diorite', 'tortora', 'antra',
    'koper', 'iron', 'rusty', 'caramel', 'pine', 'lilac', 'tuscan', 'rosy',
    'clouded', 'royal', 'transparant', 'transparent', 'licht', 'donker',
    'marble', 'marmer',
    // afwerkingen die altijd bij de kleur horen
    'washed', 'mystic', 'vintage', 'old', 'matt', 'matte', 'gloss', 'glans',
    'mat', 'shiny', 'metallic', 'antique', 'antiek'
  ];

  function inList(list, word) {
    for (var i = 0; i < list.length; i++) if (list[i] === word) return true;
    return false;
  }

  // Accenten worden weggehaald voor de vergelijking, zodat "Bronzé" en "Taupé"
  // net zo goed matchen als "bronze" en "taupe". In de getoonde kleurnaam blijft
  // het accent gewoon staan - alleen de vergelijking is accentloos.
  function clean(token) {
    var t = String(token).toLowerCase();
    if (t.normalize) t = t.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return t.replace(/[^\w-]/g, '');
  }

  function deriveFromTitle(title) {
    var tokens = String(title || '').replace(/\s+/g, ' ').trim().split(' ');
    if (!tokens.length) return { multiplier: '', category: DEFAULT_TYPE, model: '', color: '' };

    // 1. Voorloopwoorden lezen: aantal ("2x", "6x") en producttype ("Pot", "Vaas", "Mand").
    var start = 0;
    var multiplier = '';
    var category = '';
    while (start < tokens.length) {
      var lead = clean(tokens[start]);
      if (/^\d+x$/.test(lead)) {
        if (!multiplier) multiplier = lead;
        start++;
      } else if (TYPE_WORDS[lead]) {
        if (!category) category = TYPE_WORDS[lead];
        start++;
      } else if (IGNORE_LEAD[lead]) {
        start++;
      } else {
        break;
      }
    }
    var core = tokens.slice(start);
    if (!core.length) core = tokens.slice();

    // 2. Vanaf achteren kleurwoorden afpellen, stoppen bij het eerste niet-kleurwoord.
    var cut = core.length;
    while (cut > 1 && inList(COLOR_WORDS, clean(core[cut - 1]))) {
      cut--;
    }

    return {
      multiplier: multiplier,
      category: category || DEFAULT_TYPE,
      model: core.slice(0, cut).join(' '),
      color: core.slice(cut).join(' ')
    };
  }

  // Kleurnamen komen uit de producttitel en die is niet consequent: "Pot Lara
  // Copper" maar "Pot Elho Greenville golden sand". Onder de kaartjes stond dan de
  // ene keer "Copper" en de andere keer "golden sand". Elk woord een hoofdletter
  // geven trekt dat recht - "Golden Sand" naast "Rose Gold".
  function hoofdletters(tekst) {
    return String(tekst || '').replace(/\S+/g, function (woord) {
      return woord.charAt(0).toUpperCase() + woord.slice(1);
    });
  }

  function modelKey(model) {
    return String(model || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function cardInfo($card) {
    var model = $.trim($card.attr('data-pot-model') || '');
    var color = $.trim($card.attr('data-pot-color') || '');
    var title = $card.attr('data-pot-title') || $card.find('.js-quickview-toggle').attr('data-title') || '';
    var derived = deriveFromTitle(title);
    var label;

    if (model) {
      // Metafield gevuld: dat is leidend. Daar staat het producttype al in
      // ("Vaas Elisa"), dus er wordt niet nog eens een type voor geplakt.
      label = model;
    } else {
      model = derived.model || title;
      label = (derived.multiplier ? derived.multiplier + ' ' : '') +
        derived.category.charAt(0).toUpperCase() + derived.category.slice(1) +
        ' ' + model;
    }
    if (!color) color = derived.color;
    label = $.trim(label) || title;

    return {
      model: model,
      label: label,
      color: hoofdletters(color || model),
      key: modelKey(label) || modelKey(title)
    };
  }

  // ---------------------------------------------------------------------------
  // Datumsplitsing
  // ---------------------------------------------------------------------------
  // Sommige modellen bestaan twee keer in de catalogus: de oorspronkelijke
  // import en een latere batch van de leverancier, met deels dezelfde kleuren.
  // Zonder ingrijpen zie je dan twee identiek ogende kleurbolletjes naast
  // elkaar. Zodra binnen een model een kleur dubbel voorkomt, splitsen we het
  // model daarom op aanmaakdatum in een oude en een nieuwe reeks.
  //
  // De grens komt uit de dubbele kleuren zelf: de laatste "eerste keer" is het
  // einde van de oude reeks, de eerste "tweede keer" het begin van de nieuwe.
  // Alles wat daartussen valt gaat naar de reeks waar het qua datum het dichtst
  // bij ligt. Producten zonder aanmaakdatum blijven in de oude reeks.
  function colorKeyOf(card) {
    return String(card.color || '').trim().toLowerCase();
  }

  function splitGroupByDate(group) {
    if (group.cards.length < 2) return null;

    var byColor = {};
    var i, c;
    for (i = 0; i < group.cards.length; i++) {
      c = colorKeyOf(group.cards[i]);
      (byColor[c] = byColor[c] || []).push(group.cards[i]);
    }

    var oldEnd = null;
    var newStart = null;
    for (var key in byColor) {
      if (!Object.prototype.hasOwnProperty.call(byColor, key)) continue;
      var list = byColor[key];
      if (list.length === 1) continue;
      // Meer dan twee keer dezelfde kleur: te onzeker om automatisch te splitsen.
      if (list.length > 2) return null;
      var a = list[0].created;
      var b = list[1].created;
      if (!a || !b || a === b) return null;
      var first = Math.min(a, b);
      var second = Math.max(a, b);
      oldEnd = oldEnd === null ? first : Math.max(oldEnd, first);
      newStart = newStart === null ? second : Math.min(newStart, second);
    }

    if (oldEnd === null || newStart === null || oldEnd >= newStart) return null;

    var oldCards = [];
    var newCards = [];
    for (i = 0; i < group.cards.length; i++) {
      var card = group.cards[i];
      var t = card.created;
      if (!t || t <= oldEnd) oldCards.push(card);
      else if (t >= newStart) newCards.push(card);
      else if (t - oldEnd <= newStart - t) oldCards.push(card);
      else newCards.push(card);
    }
    if (!oldCards.length || !newCards.length) return null;

    // Naam van de nieuwe reeks: het jaar waarin die reeks begint.
    var earliest = newCards[0].created;
    for (i = 1; i < newCards.length; i++) {
      if (newCards[i].created && newCards[i].created < earliest) earliest = newCards[i].created;
    }
    var year = new Date(earliest * 1000).getFullYear();

    return {
      oldCards: oldCards,
      newGroup: {
        key: group.key + '-' + year,
        model: group.model,
        label: group.label + ' ' + year,
        cards: newCards
      }
    };
  }

  function splitDuplicateColorGroups() {
    var out = [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var split = splitGroupByDate(group);
      if (!split) {
        out.push(group);
        continue;
      }
      group.cards = split.oldCards;
      out.push(group);
      out.push(split.newGroup);
      byKey[split.newGroup.key] = split.newGroup;
      for (var n = 0; n < split.newGroup.cards.length; n++) {
        split.newGroup.cards[n].$el.attr('data-gb-model-key', split.newGroup.key);
      }
    }
    groups = out;
  }

  // ---------------------------------------------------------------------------
  // Opbouw
  // ---------------------------------------------------------------------------
  var QUICKVIEW_KEYS = ['title', 'price', 'pot-diameter', 'pot-opening', 'pot-material', 'pot-height', 'url', 'image'];
  var groups = [];
  var byKey = {};
  var $slider = null;
  var $colorPanel = null;
  var $geenPot = null;
  var built = false;

  function colorLabel() {
    return window.GB_POT_COLOR_LABEL || 'Kleur';
  }

  // "4 kleuren" naast de kop. Het thema heeft hier geen vertaalsleutel voor, dus
  // de acht talen van de winkel staan hier; onbekende taal valt terug op Engels.
  var KLEUREN_WOORDEN = {
    nl: 'kleuren', de: 'Farben', en: 'colours', fr: 'couleurs',
    da: 'farver', es: 'colores', pl: 'kolory', sv: 'färger'
  };
  // Zonder pot krijg je de plant in de kweekpot. Dat staat nergens, en dan lijkt
  // "geen pot" een onvolledige keuze in plaats van een prima uitkomst. Deze regel
  // verdwijnt zodra er wel een pot gekozen is.
  var GEEN_POT = {
    nl: 'Nog geen pot gekozen, je plant wordt geleverd in de kweekpot',
    de: 'Noch kein Topf gewählt, deine Pflanze wird im Anzuchttopf geliefert',
    en: 'No pot selected yet, your plant ships in its nursery pot',
    fr: 'Aucun pot sélectionné, votre plante est livrée dans son pot de culture',
    da: 'Ingen potte valgt endnu, din plante leveres i dyrkningspotten',
    es: 'Aún no has elegido maceta, tu planta se envía en su maceta de cultivo',
    pl: 'Nie wybrano jeszcze doniczki, roślina zostanie wysłana w doniczce hodowlanej',
    sv: 'Ingen kruka vald ännu, din växt levereras i odlingskrukan'
  };

  var TAAL = (document.documentElement.getAttribute('lang') || 'nl').slice(0, 2).toLowerCase();
  var KLEUREN_WOORD = KLEUREN_WOORDEN[TAAL] || KLEUREN_WOORDEN.en;
  var GEEN_POT_TEKST = GEEN_POT[TAAL] || GEEN_POT.en;

  // Kleurnamen komen uit de producttitel en gaan hieronder in een attribuut.
  // Een pot als "Grigio 12" Antique White" zou dat attribuut anders openbreken.
  function esc(tekst) {
    return String(tekst == null ? '' : tekst)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function activeCard(group) {
    for (var i = 0; i < group.cards.length; i++) {
      if (group.cards[i].$el.find('input[name="addExtraPot"]').prop('checked')) return group.cards[i];
    }
    return group.cards[0];
  }

  // ---------------------------------------------------------------------------
  // Kleurbolletjes onder de modeltegel
  // ---------------------------------------------------------------------------
  // Mini-uitsnedes van de productfoto in plaats van effen kleurvlakken. De
  // kleuren heten hier Bronze, Copper, Mystic Earth, Beige Washed - dat zijn
  // afwerkingen, geen platte kleuren, en er staat nergens een kleurwaarde in
  // Shopify. De foto klopt dus altijd en kost geen extra data.
  // Hoeveel er naast elkaar passen onder een kaart van 140 pixels hangt af van
  // het formaat. Mini-foto's zijn 26 pixels: vier passen precies, en moet er ook
  // nog een "+N" bij (26 breed) dan passen er nog drie - vier mini's plus badge
  // is 146 en loopt over de buurkaart heen. Stippen zijn 18 pixels, dus daar
  // passen er vijf, of vier met een badge erachter (gemeten: 115 van de 140).
  // De aantallen hierboven gelden voor de kaart van 140px op desktop. Op de
  // telefoon is de kaart 120px en klopte de rekensom niet meer: vijf knoppen van
  // 26px is 130px in 116px beschikbare ruimte, dus de rij stak er aan beide
  // kanten zo'n 7px uit. Links sneed de rand van de carrousel het eerste
  // bolletje af, rechts raakte hij bijna de bolletjes van de kaart ernaast.
  //
  // Smaller maken kon niet: de knop houdt min-width 26px voor het
  // WCAG-aanraakvlak van 24x24 (zie layout/theme.liquid). Dus op mobiel eentje
  // minder. Vier kaal is 104px, drie plus badge is ongeveer 104px - beide passen
  // ruim in 116px.
  var GB_SMAL = !!(window.matchMedia && window.matchMedia('(max-width: 575.98px)').matches);

  var LIMIETEN = GB_SMAL
    ? {
        foto:  { kaal: 3, metBadge: 2 },
        stip:  { kaal: 4, metBadge: 3 }
      }
    : {
        foto:  { kaal: 4, metBadge: 3 },
        stip:  { kaal: 5, metBadge: 4 }
      };

  // De mini-foto's staan ONDER de kaart, niet erin. In de kaart pasten ze niet:
  // daar is tussen de prijs bovenin en de onderrand precies genoeg ruimte voor de
  // potfoto zelf, dus alles wat je erin legt dekt de pot af - en rechtsonder zit
  // ook nog de "+"-badge. Buiten de kaart is de potfoto heel, de badge vrij en de
  // rij netjes gecentreerd. Een kleine negatieve marge laat ze net tegen de
  // onderrand aanschuiven, zodat ze visueel bij de kaart horen.
  //
  // Ze zijn wel aanklikbaar: een klik kiest die kleur meteen en klapt de
  // kleurenrij eronder open. Het zichtbare bolletje is klein, dus het raakvlak is
  // groter gemaakt dan wat je ziet (zie de ::after in de CSS) - anders zou je op
  // een telefoon voortdurend missen. De hele kaart blijft daarnaast gewoon
  // klikbaar en kiest dan de kleur die al aan stond.
  // ---------------------------------------------------------------------------
  // Welke kleuraanduiding? (A/B)
  // ---------------------------------------------------------------------------
  // Drie manieren om te tonen dat een model meer kleuren heeft:
  //
  //   foto   mini-uitsnedes van de productfoto  (variant 2, huidige kopie-thema)
  //   stip   effen bolletjes met de kleur uit die foto
  //   label  een tekstregel "4 kleuren"
  //
  // Standaard 'foto'. Een thema kan dat omzetten met window.GB_POT_SWATCH_STYLE,
  // en met ?gbpot=stip / ?gbpot=label / ?gbpot=foto kun je in elk thema handmatig
  // wisselen om ze naast elkaar te zien. Die keuze blijft binnen het tabblad
  // hangen, zodat je kunt doorklikken zonder de parameter mee te slepen.
  var STIJLEN = { foto: true, stip: true, label: true };

  function bepaalStijl() {
    var uit = null;
    try {
      var q = String(window.location.search || '').match(/[?&]gbpot=([a-z]+)/);
      if (q && STIJLEN[q[1]]) {
        uit = q[1];
        window.sessionStorage.setItem('gbPotStijl', uit);
      } else {
        var opgeslagen = window.sessionStorage.getItem('gbPotStijl');
        if (opgeslagen && STIJLEN[opgeslagen]) uit = opgeslagen;
      }
    } catch (e) {
      // Privémodus zonder sessionStorage: dan gewoon zonder onthouden verder.
    }
    if (!uit && STIJLEN[window.GB_POT_SWATCH_STYLE]) uit = window.GB_POT_SWATCH_STYLE;
    return uit || 'foto';
  }

  var STIJL = bepaalStijl();

  // ---------------------------------------------------------------------------
  // De kleur van een pot uit zijn foto halen
  // ---------------------------------------------------------------------------
  // Eerst deed dit het gemiddelde van alle niet-witte pixels. Dat is eerlijk maar
  // oogt fout: in het gemiddelde zitten ook de donkere binnenkant bij de opening
  // en de schaduw onder de pot, en die trekken hem grauw. Een gouden pot werd zo
  // olijfgroen.
  //
  // Nu wordt alleen de buik gemeten - de band over het midden, zonder rand en
  // zonder schaduw - en daarbinnen het middenveld qua helderheid, dus zonder de
  // diepste schaduwkant en zonder de witte glansplek.
  //
  // Daarna gaat er nog een correctie overheen. Een klein vlakje oogt altijd
  // doffer dan een groot vlak van dezelfde kleur, en de stip staat pal onder een
  // foto die vijf keer zo groot is. Iets meer verzadiging en licht maakt dat
  // goed. Het licht wordt opgetild met een sinus: in het midden van de schaal
  // het meest, bij bijna-zwart en bijna-wit niet - anders wordt een witte pot
  // onzichtbaar en een zwarte pot grijs.
  //
  // Mislukt het uitlezen (CORS, oud toestel), dan blijft de neutrale
  // achtergrondkleur uit de CSS staan.
  // Vooraf berekende kleuren. Zonder dit zag je bij het openen van een pagina
  // eerst een rij grijze stipjes: elke potfoto moest eerst opgehaald en
  // doorgerekend worden. Deze tabel is met exact hetzelfde recept gemaakt voor
  // alle potten die in de oppotcollecties zitten, dus de stip staat meteen goed.
  // Staat een pot er niet in - een nieuwe pot bijvoorbeeld - dan valt hij terug
  // op de mini-foto. Nooit meer een grijze stip dus.
  //
  // Bijwerken hoeft alleen als er potten bijkomen; de kleur van een bestaande
  // pot verandert niet. De sleutel is de producthandle, waarbij "pot-" is
  // ingekort tot "~" om het bestand klein te houden.
  var KLEUREN_RUW =
    'designed-by-lammie-pot-bee-green e8e3bb|designed-by-lammie-pot-cotton-cream edd4b5|designed-by-lammie-pot-fiesta-fuchsia b68b98|' +
    'elho-vibes-fold-round-antraciet 5a5c62|elho-vibes-fold-round-groen b2b760|fabien-mystic-green 656651|' +
    'mand-ivo baa287|mand-jack c79b6c|opbergmand-scott e4b581|' +
    'mand-sofia ba8b61|~alto-natural-white e5dacd|~aniek-mokka 7f6b65|' +
    '~aro-wabi-beige d9d3c4|~athena e2dacd|~aurelia-gold-d25xh19 a5a05e|' +
    '~aurelia-vintage-green 7d8057|~babet-camel ddbb80|~bordo-new-egg-earth 565551|' +
    '~bordo-new-egg-grey bab8b5|~bordo-new-egg-sand e3e0dc|~bucket-beige-washed dcd8c2|' +
    '~bucket-black 383838|~bucket-grey 969696|carly-gold efdac7|' +
    'charlie-beige-washed dccfbf|~charlie-ivory-washed eae6e0|~christina-copper d8a083|' +
    '~cilia-latte bd7f54|~elho-amber-roll-beige e7dfd6|~elho-greenville-golden-sand d1c1a3|' +
    '~elho-greenville-groen 84916f|~elho-greenville-paars 8e698b|~elho-greenville-wit f0f0ef|' +
    '~elho-greenville-zwart 4d4d4d|~elho-sereh-rond-beige d8d4c6|~elho-vibes-fold-round-linnen-wit e0dbd2|' +
    '~elho-vibes-fold-round-groen c9d7cc|~elho-vibes-fold-round-roze ddb0a5|~elisa-mystic-bronze a8aea4|' +
    '~elisa-mystic-bronze-1 997b50|~elisa-mystic-earth 98a2af|~elisa-mystic-earth-1 697267|' +
    'elisa-mystic-green addedd|~elisa-vintage-green b79000|~elisa-vintage-green-1 707758|' +
    '~elsa-creme dfceb1|~elsa-groen b0bea4|~elsa-oranje e0ae7d|' +
    '~elsa-roze dda8a7|~fabien-old-camel bf7d27|~fleuri-high-travertine-beige eee4d8|' +
    '~fleuri-travertine-beige ebe3da|~fossil-bark-d10xh8 a0937e|~grigio-new-egg-antique-white ccc9bf|' +
    '~grigio-new-egg-antraciet 575a5d|~grigio-new-egg-natural-concrete 9d9991|~harith-high-travertine-beige ede4da|' +
    '~indigo-vintage-copper 574e52|indigo-pot-vintage-gold af9874|~jenna-gold ceb69f|' +
    '~jenna-gold-1 c8bf64|~jenna-lead a99b95|~jesslyn-black 313131|' +
    '~jolien-mystic-blue 746053|~lani-wabi-beige-d25-x-h22 d9d3c4|~lara-bronze-d29xh24 9b6c4a|' +
    '~lara-gold c4b867|~lara-rose-gold b7845f|~lauri-creme efdfc6|' +
    '~lauri-lichtgroen c6c6ac|~lauri-wit e7e5e2|~lauri-zwart 6d7856|' +
    '~lena-travertine-beige e4dacf|~lizzy-beige c4ad95|~lizzy-caramel c4a98f|' +
    '~lizzy-donkerbruin 725848|~madoka-wabi-beige dad5c9|~misa-wabi-beige dbd6c5|' +
    'designed-by-lammie-pot-monstera-mystery 9ca185|~mori-wabi-beige d1cbbd|~mountain-russel a49c92|' +
    '~nella-coffee 846b5b|~palermo-groen 3e6744|~palermo-marble-clay c1b4a4|' +
    '~palermo-wit dee2dd|~palermo-zwart 1e1e20|jumbo-patt-beige-washed e4dbd1|' +
    'jumbo-patt-black-washed 828188|~petra-wit f1f1f1|~petra-zwart 332f29|' +
    '~rens-tijm bebaa2|~sempre-vintage-gold a4855b|~stijn-goud ad8973|' +
    '~stijn-goud-1 ba9a86|~stijn-zwart 2d2d2d|~stijn-zwart-1 2c2c2c|' +
    '~terreno-new-egg-ash-brown 807478|~terreno-new-egg-earth 4e4b4b|~terreno-new-egg-sand d4cfc7|' +
    'rowen-gold a67b4c|vaas-elisa-mystic-bronze 928871|vaas-lemon-fusion f1ebd9|' +
    '~bordo-balloon-grey b9b7b4|~bordo-balloon-black 555350|~bordo-balloon-beige-washed e2dfdb|' +
    '~bucket-laterite-grey 6f706b|~cascara-holly-green 44534b|charlie-black-washed 8d868c|' +
    'eggy-35cm 1e262c|~eggy-bronze 542101|~eggy-taupe a79f9a|' +
    '~eggy-wit f0f2f3|~elho-green-basics-cilinderterracotta fec5a4|~grigio-cube-antique-white dbd5ca|' +
    '~grigo-cube-antraciet 6a6e75|~grigio-cube-bronze-143045281 c19f8b|~grigo-cube-concrete a4a196|' +
    '~grigio-new-egg-bronze-143045237 c2ab9e|~jumbo-orb-beige-washed e3d9cc|~jumbo-patt-ivory-washed eeeae4|' +
    '~kyra-terra ddbca2|~orb-grey-washed cbbcac|~orb-ivory-washed f4f0ea|' +
    '~ruvido-clay c4c3bf|~ruvido-earth 5a5a5a|~ruvido-sand ece8e3|' +
    '~terreno-new-egg-clay abaaa2';

  var KLEUREN = (function () {
    var uit = {}, delen = KLEUREN_RUW.split('|');
    for (var i = 0; i < delen.length; i++) {
      var d = delen[i].split(' ');
      if (d.length === 2) uit[d[0]] = '#' + d[1];
    }
    return uit;
  })();

  function bekendeKleur(handle) {
    if (!handle) return null;
    return KLEUREN[String(handle).replace(/^pot-/, '~')] || KLEUREN[handle] || null;
  }

  // Staat een pot niet in de tabel - net toegevoegd bijvoorbeeld - dan wordt zijn
  // kleur alsnog uit de foto gehaald. Het stipje is dan even onzichtbaar in plaats
  // van grijs of een afwijkende mini-foto: liever een fractie later dan verkeerd.
  function berekenKleur(src, klaar) {
    if (!src) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var c = document.createElement('canvas');
        var W = c.width = img.naturalWidth, H = c.height = img.naturalHeight;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var d = ctx.getImageData(0, 0, W, H).data;
        var mnX = W, mnY = H, mxX = 0, mxY = 0, x, y, i, lum;
        for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
          i = (y * W + x) * 4;
          if (d[i + 3] < 40) continue;
          lum = (d[i] + d[i + 1] + d[i + 2]) / 3;
          if (lum > 236) continue;
          if (x < mnX) mnX = x; if (x > mxX) mxX = x;
          if (y < mnY) mnY = y; if (y > mxY) mxY = y;
        }
        if (mxX <= mnX || mxY <= mnY) return;
        var bw = mxX - mnX, bh = mxY - mnY;
        var y0 = Math.round(mnY + bh * 0.45), y1 = Math.round(mnY + bh * 0.85);
        var x0 = Math.round(mnX + bw * 0.20), x1 = Math.round(mnX + bw * 0.80);
        var band = [];
        for (y = y0; y <= y1; y++) for (x = x0; x <= x1; x++) {
          i = (y * W + x) * 4;
          if (d[i + 3] < 40) continue;
          lum = (d[i] + d[i + 1] + d[i + 2]) / 3;
          if (lum > 246) continue;
          band.push([d[i], d[i + 1], d[i + 2], lum]);
        }
        if (!band.length) return;
        band.sort(function (a, b) { return a[3] - b[3]; });
        var van = Math.floor(band.length * 0.70);
        var tot = Math.max(Math.floor(band.length * 0.90), van + 1);
        var r = 0, g = 0, b = 0, n = 0;
        for (i = van; i < tot && i < band.length; i++) { r += band[i][0]; g += band[i][1]; b += band[i][2]; n++; }
        if (!n) return;
        var h = naarHsl(r / n, g / n, b / n);
        klaar(naarHex(h[0], Math.min(1, h[1] * 1.25), Math.min(0.95, h[2] + 0.11 * Math.sin(Math.PI * h[2]))));
      } catch (e) {
        // Foto zonder CORS-header: dan blijft het stipje weg.
      }
    };
    // 32 px in plaats van 120. Deze afbeelding wordt nooit getoond: hij gaat
    // alleen door het canvas om de gemiddelde kleur voor het stipje te bepalen.
    // Op 32 px zijn dat nog ruim duizend pixels, meer dan genoeg voor de
    // percentielband hierboven — en het scheelt ongeveer 2 KB per potmodel.
    img.src = src.split('?')[0] + '?width=32';
  }

  function naarHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), h = 0, s = 0, l = (mx + mn) / 2;
    if (mx !== mn) {
      var d = mx - mn;
      s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      if (mx === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }
    return [h, s, l];
  }

  function naarHex(h, s, l) {
    var r, g, b;
    if (s === 0) { r = g = b = l; }
    else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q;
      var f = function (t) {
        if (t < 0) t += 1; if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };
      r = f(h + 1 / 3); g = f(h); b = f(h - 1 / 3);
    }
    return '#' + [r, g, b].map(function (v) { return ('0' + Math.round(v * 255).toString(16)).slice(-2); }).join('');
  }

  // De tabel hierboven is gemaakt door per potfoto de buik te meten - de band over
  // het midden, zonder rand en zonder schaduw - daarbinnen het middenveld qua
  // helderheid te nemen, en het resultaat iets op te tillen in verzadiging en
  // licht. Dat laatste omdat een vlakje van 18 pixels altijd doffer oogt dan de
  // foto ernaast. Komen er potten bij, dan hoort die berekening opnieuw te
  // draaien; in de winkel zelf wordt er niets meer uitgerekend.

  function buildSwatches(group) {
    if (group.cards.length < 2) return;

    var $row = $('<div class="gb-pot-model__swatches"></div>');
    $row.attr('data-stijl', STIJL);

    // Variant 3b: geen plaatjes, gewoon zeggen wat er is. Puur tekst, dus niets
    // om op te klikken - de kaart zelf opent de kleurenrij.
    if (STIJL === 'label') {
      $row.attr('aria-hidden', 'true');
      $row.append('<span class="gb-pot-model__count">' + group.cards.length + ' kleuren</span>');
      group.$tile.append($row);
      return;
    }

    var limiet = LIMIETEN[STIJL] || LIMIETEN.foto;
    var shown = group.cards.length <= limiet.kaal ? group.cards.length : limiet.metBadge;

    for (var i = 0; i < shown; i++) {
      var card = group.cards[i];
      var src = card.$el.find('.related-pots__label img').first().attr('src') || '';
      var naam = card.color || '';
      // Knop en geen span: het is een bedieningselement, dus het hoort met tab en
      // enter te werken en een schermlezer moet weten wat hij kiest.
      // De knop zelf is een doorzichtig, ruimer raakvlak; het gekleurde vlakje
      // erbinnen is wat je ziet. Dat scheelt: het vlakje moet zijn inhoud
      // afsnijden (overflow), en dat zou een groter raakvlak weer wegknippen.
      var open = '<button type="button" class="gb-pot-swatch' +
        (STIJL === 'stip' ? ' gb-pot-swatch--dot' : '') +
        '" data-swatch-index="' + i + '" title="' + esc(naam) + '" aria-label="' + esc(naam) + '">';

      if (STIJL === 'stip') {
        var vast = bekendeKleur(card.$el.attr('data-pot-handle'));
        if (vast) {
          // Kleur staat al vast: meteen goed, geen enkele tussenstand.
          $row.append(open + '<span class="gb-pot-swatch__vlak" style="background-color:' + vast + '"></span></button>');
        } else {
          // Nog onbekend: stipje onzichtbaar tonen en de kleur uit de foto halen.
          var $wacht = $(open + '<span class="gb-pot-swatch__vlak"></span></button>');
          $wacht.addClass('gb-pot-swatch--wacht');
          $row.append($wacht);
          (function ($el) {
            berekenKleur(src, function (hex) {
              $el.find('.gb-pot-swatch__vlak').css('background-color', hex);
              $el.removeClass('gb-pot-swatch--wacht');
            });
          })($wacht);
        }
      } else {
        $row.append(open +
          '<span class="gb-pot-swatch__vlak"><img src="' + src + '" alt="" loading="lazy"></span>' +
        '</button>');
      }
    }

    if (group.cards.length > shown) {
      $row.append('<span class="gb-pot-model__more" aria-hidden="true">+' + (group.cards.length - shown) + '</span>');
    }

    // Naast het label, niet erin: zo blijft de potfoto volledig zichtbaar.
    group.$tile.append($row);
  }

  function syncSwatches(group) {
    if (!group.$tile) return;
    var $swatches = group.$tile.find('.gb-pot-swatch');
    if (!$swatches.length) return;
    $swatches.each(function () {
      var i = parseInt($(this).attr('data-swatch-index'), 10);
      var card = group.cards[i];
      var on = !!(card && card.$el.find('input[name="addExtraPot"]').prop('checked'));
      $(this).toggleClass('is-active', on);
    });
  }

  function syncTile(group) {
    var card = activeCard(group);
    if (!card) return;
    var $tile = group.$tile;

    $tile.find('.related-pots__price').html(card.$el.find('.related-pots__price').html() || '');

    var $src = card.$el.find('.related-pots__label img').first();
    var $img = $tile.find('.related-pots__label img').first();
    $img.attr('src', $src.attr('src') || '');
    $img.attr('srcset', $src.attr('srcset') || '');
    $img.attr('sizes', $src.attr('sizes') || '');
    $img.attr('alt', $src.attr('alt') || '');
    // width/height meenemen uit de bron, zodat de verhouding klopt met de foto
    // die daadwerkelijk getoond wordt en er niets verspringt bij het laden.
    if ($src.attr('width')) $img.attr('width', $src.attr('width'));
    if ($src.attr('height')) $img.attr('height', $src.attr('height'));

    // Vergrootglas van de modeltegel laten wijzen naar de actieve kleur.
    var $from = card.$el.find('.js-quickview-toggle').first();
    var $to = $tile.find('.js-quickview-toggle').first();
    for (var i = 0; i < QUICKVIEW_KEYS.length; i++) {
      var k = QUICKVIEW_KEYS[i];
      var v = $from.attr('data-' + k);
      $to.attr('data-' + k, v == null ? '' : v);
      $to.data(k, v == null ? '' : v); // jQuery-cache gelijk houden
    }
  }

  function syncFromSelection() {
    var activeKey = null;
    var activeColor = '';

    var $checked = $('input[name="addExtraPot"]:checked').filter(function () {
      return !!$(this).val();
    }).first();

    if ($checked.length) {
      var $card = $checked.closest('.related-pots');
      var key = $card.attr('data-gb-model-key');
      if (key && byKey[key]) {
        activeKey = key;
        for (var i = 0; i < byKey[key].cards.length; i++) {
          if (byKey[key].cards[i].$el.is($card)) activeColor = byKey[key].cards[i].color;
        }
      }
    }

    var showPanel = false;
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var on = group.key === activeKey;
      group.$tile.toggleClass('is-active', on);
      group.$tile.find('input[name="gbPotModel"]').prop('checked', on);
      group.$group.css('display', on ? 'contents' : 'none');
      if (on && group.cards.length > 1) showPanel = true;
      syncTile(group);
      syncSwatches(group);
    }

    if ($geenPot) $geenPot.toggle(!activeKey);

    var wasZichtbaar = $colorPanel.is(':visible');
    $colorPanel.toggle(showPanel);
    $colorPanel.find('.js-gb-color-name').text(showPanel ? activeColor : '');

    var aantal = (showPanel && byKey[activeKey]) ? byKey[activeKey].cards.length : 0;
    $colorPanel.find('.js-gb-color-count').text(aantal ? aantal + ' ' + KLEUREN_WOORD : '');

    if (showPanel) {
      $colorPanel.addClass('is-open');
      // Alleen bij het OPENEN opvallen, niet bij elke kleurwissel daarna - anders
      // springt het scherm onder je handen weg terwijl je aan het kiezen bent.
      if (!wasZichtbaar) {
        $colorPanel.removeClass('gb-pot-colors--nieuw');
        // reflow forceren zodat de animatie opnieuw start
        void $colorPanel[0].offsetWidth;
        $colorPanel.addClass('gb-pot-colors--nieuw');
        brengInBeeld();
      }
    } else {
      $colorPanel.removeClass('is-open gb-pot-colors--nieuw');
    }
  }

  // Op mobiel staat de kleurenrij makkelijk onder de vouw. Zit hij niet helemaal
  // in beeld, dan schuiven we hem er rustig naartoe. Op desktop niet: daar staat
  // alles al naast elkaar en zou scrollen alleen maar storen.
  function brengInBeeld() {
    if (window.innerWidth >= 992) return;
    var el = $colorPanel[0];
    if (!el) return;
    window.setTimeout(function () {
      var r = el.getBoundingClientRect();
      var onder = window.innerHeight - 90; // ruimte voor de vaste balk onderin
      if (r.bottom <= onder && r.top >= 60) return;
      // scrollIntoView en niet window.scrollTo: dit thema laat de pagina niet
      // door het venster scrollen maar door een element eromheen, dus scrollTo
      // op window doet hier niets.
      if (el.scrollIntoView) {
        try {
          el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        } catch (e) {
          el.scrollIntoView();
        }
      }
    }, 60);
  }

  function build() {
    if (built) return;
    $slider = $('.js-oppot-slider').first();
    if (!$slider.length) return;

    var $cards = $slider.children('.related-pots').not('.related-pots--view-all');
    if ($cards.length < 2) return;
    built = true;

    // 1. Groeperen in de volgorde die het thema al bepaald heeft (collectie, dan prijs).
    $cards.each(function () {
      var $card = $(this);
      var info = cardInfo($card);
      $card.attr('data-gb-model-key', info.key);
      var group = byKey[info.key];
      if (!group) {
        group = byKey[info.key] = { key: info.key, model: info.model, label: info.label, cards: [] };
        groups.push(group);
      }
      group.cards.push({
        $el: $card,
        color: info.color,
        created: parseInt($card.attr('data-pot-created'), 10) || 0
      });
    });

    splitDuplicateColorGroups();

    // 2. Kleurpaneel onder de strook hangen.
    $colorPanel = $(
      '<div class="gb-pot-colors" style="display:none">' +
        '<div class="gb-pot-colors__heading">' +
          '<strong class="fw-semibold lh-1">' + colorLabel() + '</strong>' +
          '<span class="gb-pot-colors__value js-gb-color-name"></span>' +
          '<span class="gb-pot-colors__aantal js-gb-color-count"></span>' +
        '</div>' +
        '<div class="gb-pot-colors__row"></div>' +
      '</div>'
    );
    $slider.closest('.oppot-slider').after($colorPanel);
    $geenPot = $('<p class="gb-pot-geen"></p>').text(GEEN_POT_TEKST);
    $slider.closest('.oppot-slider').after($geenPot);
    var $row = $colorPanel.find('.gb-pot-colors__row');

    // 3. Per model: kleurgroep vullen en een modeltegel bouwen.
    var $tiles = $();
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];

      // Let op: display wordt hier expliciet gezet en er wordt bewust GEEN
      // jQuery .hide()/.show()/.toggle() gebruikt. Deze wrapper staat in de CSS
      // op display:contents, zodat de kleurkaarten zelf de flex-items van de rij
      // zijn. jQuery onthoudt bij .hide() wat de "normale" weergave van een div
      // is en zet bij .show() display:block terug - en dat overschrijft
      // display:contents. De wrapper werd dan zelf een flex-item met de kaarten
      // eronder, precies het beeld waarbij de potten onder elkaar komen te staan.
      group.$group = $('<div class="gb-pot-colors__group" data-model-key="' + group.key + '"></div>')
        .css('display', 'none');
      for (var c = 0; c < group.cards.length; c++) {
        var $kaart = group.cards[c].$el.show().addClass('gb-pot-color-card');
        // Kleurnaam onder de kaart: maakt de keuze leesbaar en het raakvlak groter.
        if (group.cards[c].color && !$kaart.find('.gb-pot-color-card__name').length) {
          $kaart.append(
            $('<span class="gb-pot-color-card__name"></span>').text(group.cards[c].color)
          );
        }
        $kaart.appendTo(group.$group);
      }
      $row.append(group.$group);

      var inputId = 'gb-pot-model-' + i;
      group.$tile = $(
        '<div class="related-pots gb-pot-model rounded-2 position-relative pb-1" data-model-key="' + group.key + '">' +
          '<input class="related-pots__input" type="radio" name="gbPotModel" id="' + inputId + '" value="' + group.key + '">' +
          '<label class="related-pots__label js-gb-select-model" for="' + inputId + '">' +
            '<span class="related-pots__price"></span>' +
            // loading="lazy" ontbrak hier. De Liquid-variantkaarten hebben het wel,
            // maar deze tegel wordt door JS opgebouwd en erfde het niet — waardoor
            // alle 31 modelfoto's meteen binnenkwamen terwijl het pottenblok onder
            // de vouw staat. width/height worden in syncTile uit de bronafbeelding
            // overgenomen; de 600x600 die hier stond klopte niet voor potfoto's die
            // bijvoorbeeld 600x545 zijn.
            '<img class="img-abs-center" alt="" loading="lazy">' +
          '</label>' +
          '<div class="related-pots__view js-quickview-toggle" data-bs-toggle="modal" data-bs-target="#exampleModal">' +
            '<i class="fa-sharp fa-solid fa-magnifying-glass"></i>' +
          '</div>' +
        '</div>'
      );
      group.$tile.attr('title', group.label);
      buildSwatches(group);
      $tiles = $tiles.add(group.$tile);
    }

    // 4. Modeltegels in de strook zetten, "alle potten bekijken" achteraan de eerste drie.
    var $viewAll = $slider.children('.related-pots--view-all').detach();
    $slider.append($tiles);

    // Alle modellen staan meteen in de strook, op elk schermformaat. De knop
    // "Alle potten bekijken" verdwijnt dus: door de kleurgroepering is de rij
    // kort genoeg om gewoon doorheen te scrollen, en een extra klik tussen de
    // klant en de rest van het assortiment kost meer dan hij oplevert.
    // Dit is exact de staat die je vroeger kreeg na een klik op die knop.
    var $placed = $slider.children('.gb-pot-model');
    $placed.show();
    $viewAll.remove();
    $slider.addClass('is-scrollable').css('overflow-x', 'scroll');
    $slider.closest('.oppot-slider-wrapper').find('.oppot-scrollbar-track').css('display', 'block');

    syncFromSelection();
    $slider.css('visibility', 'visible');
  }

  // ---------------------------------------------------------------------------
  // Events
  // ---------------------------------------------------------------------------

  // Klik op een modeltegel -> selecteer de actieve kleur van dat model.
  // Staat het model al aan, dan doet PotFinder zijn eigen toggle (= deselecteren),
  // precies zoals bij een gewone potkaart.
  $(document).on('click', '.gb-pot-model .js-gb-select-model', function (e) {
    e.preventDefault();
    var key = $(this).closest('.gb-pot-model').attr('data-model-key');
    var group = byKey[key];
    if (!group) return;
    var card = activeCard(group);
    if (!card) return;
    card.$el.find('.js-select-pot').first().trigger('click');
    window.setTimeout(syncFromSelection, 0);
  });

  // Klik op een kleurbolletje / mini-foto -> kies meteen die kleur. De rij staat
  // buiten het label, dus dit botst niet met de klik op de kaart zelf; de
  // stopPropagation is er voor het geval de opmaak ooit verandert.
  $(document).on('click', '.gb-pot-model .gb-pot-swatch', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $sw = $(this);
    var group = byKey[$sw.closest('.gb-pot-model').attr('data-model-key')];
    if (!group) return;
    var card = group.cards[parseInt($sw.attr('data-swatch-index'), 10)];
    if (!card) return;
    // Staat deze kleur al aan, dan doet PotFinder zijn eigen toggle en wordt de
    // pot losgelaten - hetzelfde gedrag als een tweede klik op de kaart.
    card.$el.find('.js-select-pot').first().trigger('click');
    window.setTimeout(syncFromSelection, 0);
  });

  // Klik op een kleurkaart -> PotFinder regelt de selectie, wij werken de tegel bij.
  $(document).on('click', '.gb-pot-color-card .js-select-pot', function () {
    window.setTimeout(syncFromSelection, 0);
  });

  // Vangnet: elke andere wijziging van de potselectie (bv. reset bij maatwissel).
  $(document).on('change', 'input[name="addExtraPot"]', function () {
    if (built) window.setTimeout(syncFromSelection, 0);
  });

  // ---------------------------------------------------------------------------
  // Wachten tot initOppotConfigurator klaar is. Dat zet visibility op visible als
  // laatste stap, dus dat is het startsein. Ruime timeout als vangnet.
  // ---------------------------------------------------------------------------
  function waitForConfigurator() {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries++;
      var slider = document.querySelector('.js-oppot-slider');
      if (!slider) {
        if (tries > 100) window.clearInterval(timer);
        return;
      }
      var ready = slider.style.visibility === 'visible' &&
        slider.querySelectorAll('.related-pots').length > 0;
      if (ready || tries > 250) {
        window.clearInterval(timer);
        if (slider.querySelectorAll('.related-pots').length > 0) build();
      }
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForConfigurator);
  } else {
    waitForConfigurator();
  }
})();
